import React from 'react';
import PoweredByShift from '../assets/PoweredByShift';
export default function BottomBar({
  title_font_family,
  title_font_size,
  accent_color,
  accent_text_color,
  isTop,
  isFat,
  logo,
  title,
  hide_poweredbyshift
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: `BottomBar ${isTop ? 'is-top' : ''}  ${isFat ? 'is-fat' : ''}`,
    style: {
      '--accent-color': accent_color,
      '--accent-text-color': accent_text_color,
      '--title-font-size': title_font_size,
      '--title-font-family': title_font_family
    }
  }, logo && /*#__PURE__*/React.createElement("img", {
    className: "logo",
    src: logo,
    alt: ""
  }), title && /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, title), !hide_poweredbyshift && /*#__PURE__*/React.createElement(PoweredByShift, {
    className: "shift-logo"
  }));
}